<template>
  <div class="login-page">
    <div class="background-container">
      <div class="background-image" v-bind:style="{'background-image':'url('+bkg+')'}"></div>
      <div class="overlay"></div>
    </div>

    <div class="content-container">
      <v-card class="login-card" elevation="10">
        <!-- Notifications et alertes -->
        <transition name="slide-fade">
          <v-alert v-if="error"
                   dense
                   class="mb-0 rounded-0"
                   color="red"
                   dark
                   border="left">
            {{ error }}
          </v-alert>
        </transition>

        <transition name="slide-fade">
          <v-alert v-if="type"
                   dense
                   class="mb-0 rounded-0"
                   :color="AlertColor(type)"
                   dark
                   border="left"
                   dismissible
                   @input="dismissible_close">
            {{ text }}
          </v-alert>
        </transition>

        <!-- Contenu principal -->
        <div class="card-content">
          <!-- En-tête avec logo -->
          <div class="text-center mb-6">
            <div class="logo-wrapper">
              <img src="@/assets/Logo_TSA_fine_short.png" alt="TSA Logo" class="logo-image" />
            </div>
            <h1 class="app-title">TERANGA</h1>
            <p class="app-subtitle">Sûreté Aéroportuaire</p>
          </div>

          <!-- Formulaire de connexion -->
          <v-form ref="form" v-model="valid" @submit.prevent="handleSubmit">
            <div v-if="!isChangePwd">
              <!-- Mode normal de connexion -->
              <v-text-field
                  ref="matriculeInput"
                  :id="dynamicID()"
                  v-model="form.matricule"
                  @focus="onMatriculeFocus"
                  @blur="onMatriculeBlur"
                  :rules="matriculeRules"
                  label="Matricule"
                  prepend-inner-icon="mdi-badge-account"
                  color="primary"
                  filled
                  rounded
                  dense
                  background-color="rgba(255, 255, 255, 0.07)"
                  :readonly="bReadOnlyConfirmCode"
                  required
                  class="input-field mb-3"
              >
                <template v-slot:append>
                  <v-icon :color="computeIconColor">
                    mdi-account-circle
                  </v-icon>
                </template>
              </v-text-field>

              <v-text-field
                  id="input2"
                  v-model="form.password"
                  :rules="passwordRules"
                  :type="show ? 'text' : 'password'"
                  color="primary"
                  filled
                  rounded
                  dense
                  background-color="rgba(255, 255, 255, 0.07)"
                  required
                  class="input-field mb-2"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show = !show"
              >
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <span>Mot de passe</span>
                    <v-tooltip bottom max-width="300">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            color="primary"
                            x-small
                            v-bind="attrs"
                            v-on="on"
                            class="ml-2 help-icon"
                        >
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                      <span>Min 6 caractères avec au moins 1 chiffre, 1 majuscule et 1 minuscule</span>
                    </v-tooltip>
                  </div>
                </template>
                <template v-slot:prepend-inner>
                  <v-icon>mdi-lock-plus</v-icon>
                </template>
              </v-text-field>
            </div>

            <div v-else>
              <!-- Mode changement de mot de passe -->
              <v-text-field
                  ref="matriculeInput"
                  :id="dynamicID()"
                  v-model="form.matricule"
                  @focus="onMatriculeFocus"
                  @blur="onMatriculeBlur"
                  :rules="matriculeRules"
                  label="Matricule"
                  prepend-inner-icon="mdi-badge-account"
                  color="primary"
                  filled
                  rounded
                  dense
                  background-color="rgba(255, 255, 255, 0.07)"
                  :readonly="bReadOnlyConfirmCode"
                  required
                  class="input-field mb-3"
              >
                <template v-slot:append>
                  <v-icon :color="computeIconColor">
                    mdi-account-circle
                  </v-icon>
                </template>
              </v-text-field>

              <div class="section-card mb-4">
                <div class="section-header">
                  <v-icon color="primary" small>mdi-lock-reset</v-icon>
                  <span>Modification du mot de passe</span>
                </div>

                <v-text-field
                    id="input2"
                    v-model="form.password"
                    :rules="passwordRules"
                    :type="show ? 'text' : 'password'"
                    color="primary"
                    filled
                    rounded
                    dense
                    background-color="rgba(255, 255, 255, 0.07)"
                    required
                    class="input-field mb-2"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show = !show"
                    :readonly="bReadOnlyConfirmCode"
                >
                  <template v-slot:label>
                    <div class="d-flex align-center">
                      <span>Nouveau mot de passe</span>
                      <v-tooltip bottom max-width="300">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                              color="primary"
                              x-small
                              v-bind="attrs"
                              v-on="on"
                              class="ml-2 help-icon"
                          >
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>Min 6 caractères avec au moins 1 chiffre, 1 majuscule et 1 minuscule</span>
                      </v-tooltip>
                    </div>
                  </template>
                  <template v-slot:prepend-inner>
                    <v-icon>mdi-lock-plus</v-icon>
                  </template>
                </v-text-field>

                <v-text-field
                    :id="dynamicID()"
                    v-model="form.confirmpassword"
                    :rules="passwordConfirmRules"
                    :type="show ? 'text' : 'password'"
                    label="Confirmation mot de passe"
                    prepend-inner-icon="mdi-lock-check"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show = !show"
                    color="primary"
                    filled
                    rounded
                    dense
                    background-color="rgba(255, 255, 255, 0.07)"
                    required
                    class="input-field"
                ></v-text-field>
              </div>

              <div v-if="sendCodeEnabled" class="section-card">
                <div class="section-header">
                  <v-icon color="primary" small>mdi-numeric</v-icon>
                  <span>Configuration du code PIN</span>
                </div>

                <v-text-field
                    :id="dynamicID()"
                    v-model="form.pinCode"
                    :rules="pinCodeRules"
                    :type="showPin ? 'text' : 'password'"
                    label="Code PIN (4 chiffres)"
                    prepend-inner-icon="mdi-numeric"
                    :append-icon="showPin ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPin = !showPin"
                    color="primary"
                    filled
                    rounded
                    dense
                    background-color="rgba(255, 255, 255, 0.07)"
                    required
                    maxlength="4"
                    class="input-field mb-2"
                    hint="Évitez les codes simples comme 1234, 0000, etc."
                    persistent-hint
                ></v-text-field>

                <v-text-field
                    :id="dynamicID()"
                    v-model="form.confirmPinCode"
                    :rules="pinCodeConfirmRules"
                    :type="showPin ? 'text' : 'password'"
                    label="Confirmation code PIN"
                    prepend-inner-icon="mdi-numeric-9-plus-box"
                    :append-icon="showPin ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPin = !showPin"
                    color="primary"
                    filled
                    rounded
                    dense
                    background-color="rgba(255, 255, 255, 0.07)"
                    :readonly="bReadOnlyConfirmCode"
                    required
                    maxlength="4"
                    class="input-field"
                ></v-text-field>
              </div>
            </div>

            <!-- Code de vérification (conditionnel) -->
            <v-text-field
                v-if="bDisplayCode"
                :id="dynamicID()"
                v-model="form.code"
                label="Code de vérification"
                prepend-inner-icon="mdi-form-textbox-password"
                hint="Entrez le code reçu par email"
                persistent-hint
                color="primary"
                filled
                rounded
                dense
                background-color="rgba(255, 255, 255, 0.07)"
                required
                class="input-field mt-3 mb-2"
            ></v-text-field>

            <!-- Message d'erreur -->
            <transition name="fade">
              <div class="error-message" v-if="errorMessage">
                <v-icon small color="error" class="mr-1">mdi-alert-circle</v-icon>
                {{ errorMessage }}
              </div>
            </transition>

            <!-- Lien de récupération et serveur -->
            <div class="d-flex justify-center mt-2 mb-4">
              <a @click="changePwd" class="recovery-link">
                {{ toggleMessage }}
              </a>
            </div>

            <!-- Sélecteur de serveur en bas, uniquement si visible -->
            <div v-if="visible" class="server-selector-container mb-3">
              <v-select
                  v-model="form.baseUrl"
                  :items="urls"
                  label="Serveur"
                  prepend-inner-icon="mdi-server"
                  color="primary"
                  hide-details
                  filled
                  rounded
                  dense
                  background-color="rgba(255, 255, 255, 0.07)"
                  class="server-select"
              >
                <template v-slot:selection="{ item }">
                  <span class="server-text">{{ item }}</span>
                </template>
              </v-select>
            </div>

            <!-- Boutons d'action -->
            <div class="action-buttons mb-2">
              <v-btn
                  v-if="bDisplayEnvoiCode"
                  :loading="loading"
                  @click.prevent="envoiCode"
                  rounded
                  depressed
                  :color="isEnvoiCodeEnabled ? 'primary' : 'grey lighten-1'"
                  :dark="isEnvoiCodeEnabled"
                  :disabled="!isEnvoiCodeEnabled"
                  elevation="2"
                  class="action-button my-2"
                  height="44"
                  block
              >
                <v-icon left>mdi-email-send</v-icon>
                Envoyer le code
              </v-btn>

              <!-- Lien de renvoi du code qui apparaît après l'envoi du code -->
              <a
                  v-if="bDisplayResendLink"
                  @click="envoiCode"
                  class="resend-link d-block text-center my-2"
              >
                <v-icon small>mdi-email-sync</v-icon>
                Renvoyer un nouveau code
              </a>

              <v-btn
                  v-if="bDisplayCodeConfirm"
                  :loading="loading"
                  @click.prevent="verifCode"
                  rounded
                  depressed
                  color="primary"
                  dark
                  elevation="2"
                  class="action-button my-2"
                  height="44"
                  block
              >
                <v-icon left>mdi-check-circle</v-icon>
                Confirmer le code
              </v-btn>

              <v-btn
                  v-if="bDisplayConnection"
                  :loading="loading"
                  @click.prevent="signin"
                  rounded
                  depressed
                  color="primary"
                  dark
                  elevation="2"
                  class="action-button my-2"
                  height="44"
                  block
              >
                <v-icon left>mdi-login</v-icon>
                {{ isChangePwd && !sendCodeEnabled ? 'Validation' : 'Connexion' }}
              </v-btn>
            </div>

            <!-- Version avec déclenchement de mise à jour via App.vue -->
            <div class="text-center version-text" @click="checkAndTriggerUpdate" style="cursor: pointer;"
                 :class="{'update-available': updateAvailable}">
              <div>Version {{ appVersion }}
                <v-icon v-if="updateAvailable" x-small color="green">mdi-update</v-icon>
              </div>
              <div v-if="updateAvailable" class="update-message">Cliquez pour mettre à jour</div>
            </div>
            <v-btn
                :visible="false"
                :href="'/help/index.html'"
                target="_blank"
                rel="noopener noreferrer"
                fab
                x-small
                class="help-button-card"
                color="blue-grey darken-2"
                elevation="2"
                style="position: absolute; bottom: 15px; right: 15px;"
            >
              <v-icon small color="white">mdi-help</v-icon>
            </v-btn>
          </v-form>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import bkgPng from '@/assets/image-analysis.png';
import apiClient from "../../config/api.js";
import moment from "moment/moment";
import packageInfo from '../../../package.json';

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

const getRandomInteger = (min, max) => {
  min = Math.ceil(min)
  max = Math.floor(max)

  return Math.floor(Math.random() * (max - min)) + min
}

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

export default {
  data() {
    return {
      sendCodeEnabled: process.env.VUE_APP_SEND_CODE === 'true',
      isMatriculeFocused: false,
      versionFrontOnServer: '',
      updateAvailable: false,
      bDisplayResendLink: false,
      matriculeRules: [
        v => v !== null && v !== undefined || 'Le matricule est obligatoire.',
        v => {
          if (v === null || v === undefined) return true; // Déjà géré par la règle précédente
          return (/^[0-9]{1,10}$/.test(v) || v.toLowerCase().includes("admin")) || 'Matricule invalide';
        }
      ],

      // Règles de validation pour le mot de passe
      passwordRules: [
        v => v !== null && v !== undefined || 'Le mot de passe est obligatoire.',
        v => {
          if (v === null || v === undefined) return true; // Déjà géré par la règle précédente
          return /\d/.test(v) || 'Le mot de passe doit contenir au moins 1 chiffre.';
        },
        v => {
          if (v === null || v === undefined) return true;
          return /[A-Z]{1}/.test(v) || 'Le mot de passe doit contenir au moins 1 majuscule.';
        },
        v => {
          if (v === null || v === undefined) return true;
          return /[a-z]{1}/.test(v) || 'Le mot de passe doit contenir au moins 1 minuscule.';
        },
        v => {
          if (v === null || v === undefined) return true;
          return v.length > 5 || 'Le mot de passe doit contenir au minimum 6 caractères.';
        }
      ],

      // Règles de validation pour la confirmation du mot de passe
      passwordConfirmRules: [
        v => v !== null && v !== undefined || 'La confirmation du mot de passe est obligatoire.',
        v => {
          if (v === null || v === undefined) return true;
          return v === this.form.password || 'Les mots de passe ne correspondent pas.';
        }
      ],

      // Règles de validation pour le code PIN
      pinCodeRules: [
        v => v !== null && v !== undefined || 'Le code PIN est obligatoire.',
        v => {
          if (v === null || v === undefined) return true;
          if (!/^\d{4}$/.test(v)) return 'Le code PIN doit contenir exactement 4 chiffres.';

          const simplePINs = [
            '0000', '1111', '2222', '3333', '4444', '5555', '6666', '7777', '8888', '9999',
            '1234', '2345', '3456', '4567', '5678', '6789', '0123',
            '4321', '5432', '6543', '7654', '8765', '9876', '3210'
          ];

          if (simplePINs.includes(v)) {
            this.errorMessage = "Ce code PIN est trop simple. Veuillez choisir un code plus sécurisé.";
            return 'Code PIN trop simple';
          }

          // Si le code PIN est valide, effacer le message d'erreur
          if (this.errorMessage && this.errorMessage.includes("PIN")) {
            this.errorMessage = "";
          }

          return true;
        }
      ],

      // Règles de validation pour la confirmation du code PIN
      pinCodeConfirmRules: [
        v => v !== null && v !== undefined || 'La confirmation du code PIN est obligatoire.',
        v => {
          if (v === null || v === undefined) return true;
          return v === this.form.pinCode || 'Les codes PIN ne correspondent pas.';
        }
      ],

      // Règles de validation pour le code de vérification
      codeRules: [
        v => v !== null && v !== undefined || 'Le code de vérification est obligatoire.'
      ],

      appVersion: packageInfo.version,
      timeMealtypes: ["Déjeuner", "Diner"],
      bReadOnlyConfirmCode: false,
      bDisplayConnection: true,
      bMatriculeOK: false,
      bPwdOK: false,
      bPwdOKConfirm: false,
      bPinOK: false,
      bPinOKConfirm: false,
      bDisplayPwdConfirm: false,
      bDisplayCode: false,
      bDisplayEnvoiCode: false,
      bDisplayCodeConfirm: false,
      bCodeOK: false,
      logoutTimer: null,
      token: "",
      randomInteger: "",
      baseUrlTmp: "",
      username: "",
      isChangePwd: false,
      errorMessage: "",
      showPin: false,
      stateObj: {
        register: {
          name: 'Validation',
          message: 'Retour à la connexion'
        },
        login: {
          name: 'Oubli mot de passe',
          message: 'Mot de passe oublié ou 1ère connexion ?'
        }
      },

      isMobile: isMobileDevice(),
      bkg: bkgPng,
      hover: false,
      image: '',
      imageUrl: '',
      type: null,
      text: null,
      valid: false,
      show: false,
      listEndPoints:
          [
            'Local',
            'Test',
            'Prod'
          ],
      form: {
        code: "",
        matricule: "",
        password: "",
        confirmpassword: "",
        pinCode: "",
        confirmPinCode: "",
        baseUrl: process.env.VUE_APP_ENVIRONMENT || "Local"
      },
      visible: false
    };
  },
  props: {
    externalUrl: {}
  },
  mounted: function () {
    this.checkPendingUpdates();
  },
  beforeRouteEnter(to, from, next) {
    // Vérifier si l'URL contient le mot-clé 'database' dans les paramètres de requête
    if (Object.hasOwn(to.query, 'database')) {
      next((vm) => {
        vm.visible = true;
      });
    } else {
      next();
    }
  },
  computed: {
    computeIconColor() {
      if (this.bReadOnlyConfirmCode) return 'grey';
      if (this.isMatriculeFocused) return 'primary';  // Use the new data property
      return ''; // Inherits inactive color
    },
    isEnvoiCodeEnabled() {
      if (!this.isChangePwd) {
        // Mode connexion normale - vérification de base
        return this.bMatriculeOK && this.bPwdOK;
      } else {
        // Mode changement de mot de passe
        const pwdMatch = this.form.password && this.form.confirmpassword &&
            this.form.password === this.form.confirmpassword;

        // If sendCodeEnabled is false, skip PIN validation (default PIN is set)
        if (!this.sendCodeEnabled) {
          return this.bMatriculeOK &&
              this.bPwdOK &&
              this.bPwdOKConfirm &&
              pwdMatch;
        }

        // Vérifier si le code PIN est parmi les codes simples
        let isPinValid = this.bPinOK;
        if (this.form.pinCode && /^\d{4}$/.test(this.form.pinCode)) {
          const simplePINs = [
            '0000', '1111', '2222', '3333', '4444', '5555', '6666', '7777', '8888', '9999',
            '1234', '2345', '3456', '4567', '5678', '6789', '0123',
            '4321', '5432', '6543', '7654', '8765', '9876', '3210'
          ];
          isPinValid = !simplePINs.includes(this.form.pinCode);
        }

        const pinMatch = this.form.pinCode && this.form.confirmPinCode &&
            this.form.pinCode === this.form.confirmPinCode;

        return this.bMatriculeOK &&
            this.bPwdOK &&
            this.bPwdOKConfirm &&
            isPinValid &&
            this.bPinOKConfirm &&
            pwdMatch &&
            pinMatch;
      }
    },
    toggleMessage: function () {
      return this.isChangePwd ? this.stateObj.register.message : this.stateObj.login.message
    },
    userBrigade() {
      return this.$store.getters.user.brigade;
    },
    user() {
      return this.$store.getters.user;
    },
    error() {
      return this.$store.getters.error;
    },
    loading() {
      return this.$store.getters.loading;
    },
    FormIsValid() {
      return (
          this.form.matricule !== "" &&
          this.form.password !== "" &&
          this.form.baseUrl !== ""
      );
    },
    urls() {
      return [
        "Local",
        "Test",
        "Prod"
      ];
    },
  },
  watch: {
    // Surveiller si une mise à jour est disponible dans App.vue
    '$root.showUpdateNotification': function (newVal) {
      if (newVal === true) {
        this.updateAvailable = true;
      }
    },

    // Surveiller le champ matricule
    'form.matricule': function (val) {
      // Vérifier si le matricule est valide (5 chiffres ou contient "admin")
      this.bMatriculeOK = val && (/^[0-9]{1,10}$/.test(val) || val.toLowerCase().includes("admin"));

      // Réinitialiser le message d'erreur si le champ est valide
      if (this.bMatriculeOK) {
        this.errorMessage = null;
      }
    },

    // Surveiller le champ mot de passe
    'form.password': function (val) {
      // Vérifier si le mot de passe respecte tous les critères
      this.bPwdOK = val &&
          /\d/.test(val) &&
          /[A-Z]{1}/.test(val) &&
          /[a-z]{1}/.test(val) &&
          val.length > 5;

      // Réinitialiser le message d'erreur si le champ est valide
      if (this.bPwdOK) {
        this.errorMessage = null;
      }

      // Vérifier également la confirmation de mot de passe si elle existe déjà
      if (this.form.confirmpassword) {
        this.bPwdOKConfirm = this.form.confirmpassword === val;
      }
    },

    // Surveiller le champ de confirmation du mot de passe
    'form.confirmpassword': function (val) {
      // Vérifier si la confirmation correspond au mot de passe
      this.bPwdOKConfirm = val && val === this.form.password;

      // Réinitialiser le message d'erreur si le champ est valide
      if (this.bPwdOKConfirm) {
        this.errorMessage = null;
      }
    },

    // Surveiller le champ code PIN
    'form.pinCode': function (val) {
      // Vérifier si le code PIN contient exactement 4 chiffres
      if (val && /^\d{4}$/.test(val)) {
        const simplePINs = [
          '0000', '1111', '2222', '3333', '4444', '5555', '6666', '7777', '8888', '9999',
          '1234', '2345', '3456', '4567', '5678', '6789', '0123',
          '4321', '5432', '6543', '7654', '8765', '9876', '3210'
        ];

        if (simplePINs.includes(val)) {
          this.bPinOK = false;
          this.errorMessage = "Ce code PIN est trop simple. Veuillez choisir un code plus sécurisé.";
          // Important: ne pas réinitialiser form.pinCode ici, permettre à l'utilisateur de le modifier
        } else {
          this.bPinOK = true;
          // Effacer le message d'erreur lié au PIN
          if (this.errorMessage && this.errorMessage.includes("PIN")) {
            this.errorMessage = "";
          }
        }
      } else {
        this.bPinOK = false;
      }

      // Vérifier également la confirmation du PIN si elle existe déjà
      if (this.form.confirmPinCode) {
        this.bPinOKConfirm = this.form.confirmPinCode === val;
      }
    },

    // Surveiller le champ de confirmation du code PIN
    'form.confirmPinCode': function (val) {
      // Vérifier si la confirmation correspond au code PIN
      this.bPinOKConfirm = val && val === this.form.pinCode;

      // Réinitialiser le message d'erreur si le champ est valide
      if (this.bPinOKConfirm) {
        this.errorMessage = null;
      }
    },

    // Surveiller le champ code de vérification
    'form.code': function (val) {
      // Marquer le code comme valide s'il existe
      this.bCodeOK = !!val;
    },

    // Surveiller les changements de mode
    'isChangePwd': function (val) {
      // Réinitialiser les états de validation appropriés lors du changement de mode
      if (val) {
        // Mode changement de mot de passe
        this.bPwdOKConfirm = false;
        this.bPinOK = false;
        this.bPinOKConfirm = false;
      } else {
        // Mode connexion
        this.bCodeOK = false;
      }

      // Réinitialiser le message d'erreur
      this.errorMessage = null;
    },

    user(value) {
      if (value !== null && value !== undefined) {
        if (value.role === "ADMINISTRATOR") {
          this.$router.push("/dashboard").catch(err => {
            // Ignore the vuex err regarding  navigating to the page they are already on.
            if (
                err.name !== 'NavigationDuplicated' &&
                !err.message.includes('Avoided redundant navigation to current location')
            ) {
              // But print any other errors to the console
            }
          });
        } else {
          let sRoute;
          if (value.role === "ADMINISTRATOR") {
            sRoute = "/agents/liste_principale";
          } else if (value.role === "FRONT") {
            sRoute = "/cards/cmdCards";
          } else if (value.role === "TPE") {
            sRoute = "/pointages/infos_tpe";
          } else if ((value.role === "RESTAURATEUR") || (value.role === "POINT FOCAL RESTO")) {
            sRoute = "/agents/commandes";
          } else if ((this.userBrigade === "TSA-BRG-MFD") || (this.userBrigade === "TSA-BRG-ANF") || (value.userId === "18106")
              || (value.userId === "91804") || (value.userId === "92204") || (value.userId === "19001") || (value.userId === "20052") || (value.userId === "92208")
              || (value.userId === "22014") || (value.userId === "19129") || (value.userId === "18046") || (value.userId === "19385") || (value.userId === "18108")
              || (value.userId === "18004") || (value.userId === "21029") || (value.userId === "18075")) {
            sRoute = "/agents/liste_principale";
          } else {
            sRoute = "/agents/commandesindividuelles";
          }

          this.$router.push(sRoute).catch(err => {
            // Ignore the vuex err regarding  navigating to the page they are already on.
            if (
                err.name !== 'NavigationDuplicated' &&
                !err.message.includes('Avoided redundant navigation to current location')
            ) {
              // But print any other errors to the console
            }
          });
        }
      }
    },
  },
  methods: {
    // Helper method to get base URL from environment or fallback to hardcoded logic
    getBaseUrl(environment = null) {
      const env = environment || this.form.baseUrl;
      
      // First try to get from environment variable
      if (process.env.VUE_APP_BASE_URL) {
        return process.env.VUE_APP_BASE_URL;
      }
      
      // Fallback to hardcoded logic
      if (env === "Prod")
        return "https://tsarh.cartaware.cartalink.com";
      else if (env === "Test")
        return "https://tests.eyone.cartaware.cartalink.com";
      else
        return "http://localhost:8082";
    },

    // Dialog personnalisé pour gérer les pop-ups bloqués
    showPopupBlockedDialog() {
      this.$confirm('Les pop-ups sont bloqués par votre navigateur.<br>Voulez-vous ouvrir l\'aide dans cet onglet ?', {
        title: 'Pop-up bloqué',
        confirmButtonText: 'Ouvrir ici',
        cancelButtonText: 'Annuler',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        // Ouvrir dans le même onglet
        window.location.href = '/help/index.html';
      }).catch(() => {
        // L'utilisateur a annulé
        this.text = "Pour accéder à l'aide, autorisez les pop-ups ou tapez manuellement : " + window.location.origin + "/help/index.html";
        this.showAlert('info', 8000);
      });
    },
    onMatriculeFocus() {
      this.isMatriculeFocused = true;
    },
    onMatriculeBlur() {
      this.isMatriculeFocused = false;
    },
    checkPendingUpdates() {
      try {
        const pendingUpdateStr = sessionStorage.getItem('pendingUpdate');
        if (!pendingUpdateStr) return;

        const pendingUpdate = JSON.parse(pendingUpdateStr);
        if (pendingUpdate && pendingUpdate.version) {
          this.versionFrontOnServer = pendingUpdate.version;

          // Vérifier si la version enregistrée est plus récente que la version actuelle
          if (this.isNewerVersion(this.versionFrontOnServer, this.appVersion)) {
            this.updateAvailable = true;
          }
        }
      } catch (error) {
        console.error("Erreur lors de la vérification des mises à jour en attente:", error);
      }
    },

    // Ajouter ces méthodes à l'objet methods de Login.vue
    checkAndTriggerUpdate() {
      // Si une mise à jour est déjà disponible, l'appliquer directement
      if (this.updateAvailable) {
        this.forceAppUpdate();
        return;
      }

      // Sinon, vérifier s'il y a une nouvelle version
      this.checkVersion();
    },

    checkVersion() {
      // Déterminer l'URL de base selon l'environnement
      const baseUrlTmp = this.getBaseUrl();

      // Vérifier si une nouvelle version est disponible
      apiClient
          .get(`${baseUrlTmp}/account/versionfront?nocache=${Date.now()}`)
          .then(response => {
            if (response && response.data && response.data.datas) {
              const serverVersion = response.data.datas;

              // Vérifier si la version du serveur est plus récente
              if (this.isNewerVersion(serverVersion, this.appVersion)) {
                // Marquer qu'une mise à jour est disponible
                this.updateAvailable = true;
                this.versionFrontOnServer = serverVersion;

                // Informer l'utilisateur
                this.text = `Nouvelle version disponible (${serverVersion}).`;
                this.showAlert('info', 5000);

                // Stocker l'information de mise à jour dans sessionStorage pour qu'App.vue puisse la récupérer
                sessionStorage.setItem('pendingUpdate', JSON.stringify({
                  version: serverVersion,
                  checkDate: new Date().toISOString()
                }));
              } else {
                // Informer que l'application est à jour
                this.text = "Votre application est à jour.";
                this.showAlert('info', 3000);
              }
            }
          })
          .catch(error => {
            console.error("Erreur lors de la vérification de version:", error);
            this.text = "Impossible de vérifier les mises à jour.";
            this.showAlert('error', 3000);
          });
    },

    isNewerVersion(versionA, versionB) {
      // Fonction pour comparer deux numéros de version
      // Retourne true si versionA est plus récente que versionB

      // Normaliser les versions (retirer les zéros non significatifs)
      const normalizedA = versionA.replace(/\.0+(\d)/g, ".$1");
      const normalizedB = versionB.replace(/\.0+(\d)/g, ".$1");

      const partsA = normalizedA.split('.');
      const partsB = normalizedB.split('.');

      // Comparer chaque partie de la version
      for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
        const numA = parseInt(partsA[i] || 0);
        const numB = parseInt(partsB[i] || 0);

        if (numA > numB) return true;
        if (numA < numB) return false;
      }

      // Versions identiques
      return false;
    },

    forceAppUpdate() {
      // Supprimer les drapeaux de mise à jour en attente
      // Supprimer les drapeaux de mise à jour en attente
      sessionStorage.removeItem('pendingUpdate');
      sessionStorage.removeItem('updateLater');

      // Recharger la page avec un paramètre anti-cache
      window.location.href = window.location.href.split('?')[0] + `?forceUpdate=${Date.now()}`;
    },

    debouncedMatriculeRules: debounce(function () {
      this.matriculeRules();
    }, 300), // 300ms de délai

    debouncedPasswordRules: debounce(function () {
      this.passwordRules();
    }, 300),

    debouncedPasswordConfirmRules: debounce(function () {
      this.passwordConfirmRules();
    }, 300),

    debouncedPinCodeRules: debounce(function () {
      this.pinCodeRules();
    }, 300),

    debouncedPinCodeConfirmRules: debounce(function () {
      this.pinCodeConfirmRules();
    }, 300),
    isNumber(value) {
      return (value && /^[0-9]+$/.test(value));
    },
    handleSubmit() {
      this.valid = this.$refs.form.validate()
    },
    login() {
      const {username} = this;
      // console.log(username + "logged in")
    },
    changePwd() {
      this.isChangePwd = !this.isChangePwd;

      // Initialiser les valeurs à des chaînes vides plutôt que null
      this.form.password = "";
      this.form.confirmpassword = "";
      this.form.matricule = "";
      this.form.code = "";

      if (this.isChangePwd) {
        this.bDisplayPwdConfirm = true;
        this.bDisplayConnection = false;

        // Conditionally show "Send Code" button based on environment variable
        if (this.sendCodeEnabled) {
          this.form.pinCode = "";
          this.form.confirmPinCode = "";
          this.bDisplayEnvoiCode = true;
          this.bDisplayResendLink = false;
          this.bDisplayCodeConfirm = false;
          this.bDisplayCode = false;
        } else {
          // Skip code verification - set default PIN and show connection button directly
          this.form.pinCode = "1590";
          this.form.confirmPinCode = "1590";
          this.bPinOK = true;
          this.bPinOKConfirm = true;
          this.bDisplayEnvoiCode = false;
          this.bDisplayResendLink = false;
          this.bDisplayCodeConfirm = false;
          this.bDisplayCode = false;
          this.bDisplayConnection = true;
        }
      } else {
        // Retour à la page de connexion normale
        this.bDisplayEnvoiCode = false;
        this.bDisplayCodeConfirm = false;
        this.bDisplayPwdConfirm = false;
        this.bDisplayConnection = true;
        this.bReadOnlyConfirmCode = false;
        this.bDisplayEnvoiCode = false;
        this.bDisplayCode = false;
        this.bDisplayResendLink = false;
        this.bCodeOK = null;
      }

      // Réinitialiser les validations
      this.bMatriculeOK = false;
      this.bPwdOK = false;
      this.bPwdOKConfirm = false;
      this.bPinOK = false;
      this.bPinOKConfirm = false;

      // Réinitialiser les erreurs
      this.errorMessage = "";

      clearTimeout(this.logoutTimer);
    },
    register() {
      if (this.form.password === this.form.confirmpassword) {
        this.errorMessage = "";
        return true;
      } else {
        this.errorMessage = "Mots de passe différents"
        setTimeout(() => {
          this.errorMessage = "";
        }, 3000);
        return false;
      }
    },
    nextPlease: function (event) {
      document.getElementById('input2').focus();
    },
    setImage() {
      if (!this.externalUrl) {
        return;  // Ne pas continuer si externalUrl n'est pas définie
      }

      this.imageUrl = this.externalUrl;
      this.image = '';
      var that;
      var highResImage = new Image();

      that = this;
      highResImage.onload = function () {
        that.image = that.imageUrl;
      }
      highResImage.src = that.imageUrl;
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type, timout) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, timout)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, timout)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    envoiCode() {
      if (!this.isEnvoiCodeEnabled) {
        return;
      }

      this.bDisplayCode = true;
      this.bCodeOK = false;
      this.form.code = null;
      this.bDisplayCodeConfirm = true;
      this.bReadOnlyConfirmCode = true;

      // Masquer le bouton "Envoyer code" après le clic
      this.bDisplayEnvoiCode = false;

      this.baseUrlTmp = this.getBaseUrl();

      apiClient
          .post(`${this.baseUrlTmp}/auth/signin`, {
            emailAddress: "admin" + "@cartalink.com",
            password: "C@rT@L1nK2016"
          })
          .then(response => {
            if (response.data.status === 200) {
              this.token = response.data.access_token;
              sessionStorage.setItem("token", this.token);
              this.randomInteger = getRandomInteger(10001, 99999);

              // Envoi du code par email
              apiClient
                  .post(
                      `${this.baseUrlTmp}/sendcode/` + this.randomInteger + "/" + this.form.matricule
                  )
                  .then(response => {
                    if (response.data.status === 200) {
                      this.text = "Le code vous a été envoyé par email.\nVous avez 5 min pour le saisir.";
                      this.showAlert('info', 10000);

                      // Ajouter un lien de renvoi du code
                      this.bDisplayResendLink = true;

                      this.logoutTimer = setTimeout(() => {
                        this.changePwd();
                      }, 300000);
                    } else {
                      this.text = response.data.message;
                      this.showAlert('error', 10000);

                      // Attendre 10 secondes puis revenir à la page de connexion
                      setTimeout(() => {
                        this.changePwd();
                      }, 10000);

                      this.$store.dispatch("logout").then(() => {
                        this.$router.push("/").catch(err => {
                          if (err.name !== 'NavigationDuplicated') {
                            // Gérer l'erreur si nécessaire
                          }
                        });
                      });
                    }

                    this.$store.dispatch("logout").then(() => {
                      this.$router.push("/").catch(err => {
                        if (err.name !== 'NavigationDuplicated') {
                          // Gérer l'erreur si nécessaire
                        }
                      });
                    });
                  })
                  .catch(() => {
                    this.text = "Serveur inaccessible.\nContactez l'administrateur.";
                    this.showAlert('error', 10000);

                    // Attendre 10 secondes puis revenir à la page de connexion
                    setTimeout(() => {
                      this.changePwd();
                    }, 10000);

                    this.$store.dispatch("logout").then(() => {
                      this.$router.push("/").catch(err => {
                        if (err.name !== 'NavigationDuplicated') {
                          // Gérer l'erreur si nécessaire
                        }
                      });
                    });
                  });
            } else {
              this.text = "Serveur inaccessible.\nContactez l'administrateur.";
              this.showAlert('error', 10000);

              // Attendre 10 secondes puis revenir à la page de connexion
              setTimeout(() => {
                this.changePwd();
              }, 10000);

              this.$store.dispatch("logout").then(() => {
                this.$router.push("/").catch(err => {
                  if (err.name !== 'NavigationDuplicated') {
                    // Gérer l'erreur si nécessaire
                  }
                });
              });
            }
          })
          .catch(error => {
            this.text = "Serveur inaccessible.\nContactez l'administrateur.";
            this.showAlert('error', 10000);

            // Attendre 10 secondes puis revenir à la page de connexion
            setTimeout(() => {
              this.changePwd();
            }, 10000);

            this.$store.dispatch("logout").then(() => {
              this.$router.push("/").catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                  // Gérer l'erreur si nécessaire
                }
              });
            });
          });
    },
    verifCode() {
      // Vérifier toutes les validations nécessaires
      if (((!this.bMatriculeOK || !this.bPwdOK) && !this.isChangePwd) ||
          ((!this.bMatriculeOK || !this.bPwdOK || !this.bPwdOKConfirm || !this.bPinOK || !this.bPinOKConfirm) && this.isChangePwd)) {

        if ((!this.bMatriculeOK || !this.bPwdOK) && !this.isChangePwd) {
          this.matriculeRules() && this.passwordRules();
        } else {
          // Vérifions tous les champs requis pour le changement de mot de passe
          this.matriculeRules();
          this.passwordRules();
          this.passwordConfirmRules();
          this.pinCodeRules();
          this.pinCodeConfirmRules();
        }
        return;
      }

      let actualDate = moment().format("YYYY-MM-DD").toString()
      let actualHour = moment().format("HH:mm:ss").toString()
      let day = this.getDay(actualDate)
      let hour = this.getHour(actualHour)
      let codeTemp = day + hour + this.digitSum(this.form.matricule)
      codeTemp = codeTemp.split('').reverse().join('')

      if (!this.isEmpty(this.form.code) && ((this.form.code.localeCompare(codeTemp) === 0) || ((this.isNumber(this.form.code) && this.form.code.localeCompare(this.randomInteger)) === 0))) {
        this.bDisplayConnection = true;
        this.bDisplayCodeConfirm = false;
        this.bDisplayResendLink = false;

        apiClient
            .post(`${this.baseUrlTmp}/auth/signin`, {
              emailAddress: "admin" + "@cartalink.com",
              password: "C@rT@L1nK2016"
            })
            .then(response => {
              if (response.data.status === 200) {
                this.token = response.data.access_token;
                sessionStorage.setItem("token", this.token);

                // Mise à jour du mot de passe
                apiClient
                    .post(
                        `${this.baseUrlTmp}/account/user/passwordbyuser/` + this.form.matricule + "/" + this.form.password + "/" + "Admin"
                    )
                    .then(response => {
                      if (response.data.status === 200) {
                        // Mise à jour du code PIN (à implémenter avec votre endpoint)
                        if (this.isChangePwd && this.bPinOK && this.bPinOKConfirm) {
                          // Appel à votre endpoint pour mettre à jour le code PIN
                          apiClient
                              .post(
                                  `${this.baseUrlTmp}/account/user/pincode_by_matricule/` + this.form.matricule + "/" + this.form.pinCode + "/" + "Admin"
                              )
                              .then(pinResponse => {
                                if (pinResponse.data.status === 200) {
                                  this.text = "Modification du mot de passe et du code PIN effectuée.\nVeuillez vous connecter.";
                                } else {
                                  this.text = "Modification du mot de passe effectuée mais échec de la mise à jour du code PIN.\nVeuillez vous connecter.";
                                }
                                this.showAlert('info', 10000);

                                this.completePasswordChange();
                              })
                              .catch(() => {
                                this.text = "Modification du mot de passe effectuée mais échec de la mise à jour du code PIN.\nVeuillez vous connecter.";
                                this.showAlert('info', 10000);

                                this.completePasswordChange();
                              });
                        } else {
                          this.text = "Modification du mot de passe effectuée.\nVeuillez vous connecter.";
                          this.showAlert('info', 10000);

                          this.completePasswordChange();
                        }
                      } else {
                        this.text = response.data.message;
                        this.showAlert('error', 10000);

                        // Attendre 10 secondes puis revenir à la connexion
                        setTimeout(() => {
                          this.changePwd();
                        }, 10000);

                        this.$store.dispatch("logout").then(() => {
                          this.$router.push("/").catch(err => {
                            if (err.name !== 'NavigationDuplicated') {
                              // Gérer l'erreur si nécessaire
                            }
                          });
                        });
                      }
                    })
                    .catch(() => {
                      this.text = "Serveur inaccessible.\nContactez l'administrateur.";
                      this.showAlert('error', 10000);

                      // Attendre 10 secondes puis revenir à la connexion
                      setTimeout(() => {
                        this.changePwd();
                      }, 10000);

                      this.$store.dispatch("logout").then(() => {
                        this.$router.push("/").catch(err => {
                          if (err.name !== 'NavigationDuplicated') {
                            // Gérer l'erreur si nécessaire
                          }
                        });
                      });
                    });
              } else {
                this.text = "Serveur inaccessible.\nContactez l'administrateur.";
                this.showAlert('error', 10000);

                // Attendre 10 secondes puis revenir à la connexion
                setTimeout(() => {
                  this.changePwd();
                }, 10000);

                this.$store.dispatch("logout").then(() => {
                  this.$router.push("/").catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                      // Gérer l'erreur si nécessaire
                    }
                  });
                });
              }
            })
            .catch(error => {
              this.text = "Serveur inaccessible.\nContactez l'administrateur.";
              this.showAlert('error', 10000);

              // Attendre 10 secondes puis revenir à la connexion
              setTimeout(() => {
                this.changePwd();
              }, 10000);

              this.$store.dispatch("logout").then(() => {
                this.$router.push("/").catch(err => {
                  if (err.name !== 'NavigationDuplicated') {
                    // Gérer l'erreur si nécessaire
                  }
                });
              });
            });
      } else {
        this.text = "Code de vérification incorrect";
        this.form.code = null;
        this.showAlert('warn', 5000);
      }
    },
    // Nouvelle méthode pour finaliser le changement de mot de passe
    completePasswordChange() {
      apiClient
          .post(
              `${this.baseUrlTmp}/account/savechangepassword/` + this.form.matricule + "/" + this.form.code + "/" + this.form.password + "/DIRECT/" + this.form.matricule
          )
          .then(() => {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/").catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                  // Gérer l'erreur si nécessaire
                }
              });

              this.changePwd();
            });
          })
          .catch(() => {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/").catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                  // Gérer l'erreur si nécessaire
                }
              });
            });

            this.changePwd();
          });
    },
    digitSum(n) {
      // Vérifier si n est null, undefined ou vide
      if (n === null || n === undefined || n === '') {
        return 0;
      }

      // Si n est une chaîne, vérifier si elle contient uniquement des chiffres
      if (typeof n === 'string') {
        // Rejeter toute chaîne qui n'est pas composée uniquement de chiffres
        if (!/^\d+$/.test(n)) {
          return 0;
        }
        // Convertir la chaîne numérique en nombre
        n = parseInt(n, 10);
      }

      // Si n n'est pas un nombre à ce stade, rejeter
      if (typeof n !== 'number' || isNaN(n)) {
        return 0;
      }

      // Version itérative (non récursive) pour éviter les débordements de pile
      let num = n;
      while (num >= 10) {
        let sum = 0;
        while (num > 0) {
          sum += num % 10;
          num = Math.floor(num / 10);
        }
        num = sum;
      }

      return num;
    },
    getDay(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}`
    },
    getMonth(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}`
    },
    getHour(time) {
      if (!time) return null

      const [hh, mm, ss] = time.split(':')
      return `${hh}`
    },
    isEmpty(str) {
      return (str === null || !str || 0 === str.length || /^\s*$/.test(str));
    },
    signin() {
      clearTimeout(this.logoutTimer);
      let matricule = "";

      // Check if this is a password change operation without code verification
      if (this.isChangePwd && !this.sendCodeEnabled) {
        this.updatePasswordWithoutCode();
        return;
      }

      // Connexion normale
      if (!this.FormIsValid) {
        this.text = "Saisissez votre matricule puis mot de passe."
        this.showAlert('warn', 5000)
      } else {
        // Si le matricule contient déjà '@', l'utiliser tel quel
        // Sinon, ajouter "@jabali.sn"
        matricule = this.form.matricule === 'admin'
            ? 'admin@cartalink.com'
            : this.form.matricule + '@jabali.sn';

        const baseUrlTmp = this.getBaseUrl();

        this.$store.dispatch("loginUser", {
          emailAddress: matricule,
          password: this.form.password,
          baseUrl: baseUrlTmp
        })
      }
    },
    updatePasswordWithoutCode() {
      // Validate all required fields (PIN is automatically set to 1590)
      if (!this.bMatriculeOK || !this.bPwdOK || !this.bPwdOKConfirm) {
        this.errorMessage = "Veuillez remplir tous les champs correctement.";
        setTimeout(() => {
          this.errorMessage = "";
        }, 5000);
        return;
      }

      this.baseUrlTmp = this.getBaseUrl();

      // Authenticate as admin to perform the password update
      apiClient
          .post(`${this.baseUrlTmp}/auth/signin`, {
            emailAddress: "admin" + "@cartalink.com",
            password: "C@rT@L1nK2016"
          })
          .then(response => {
            if (response.data.status === 200) {
              this.token = response.data.access_token;
              sessionStorage.setItem("token", this.token);

              // Update password
              apiClient
                  .post(
                      `${this.baseUrlTmp}/account/user/passwordbyuser/` + this.form.matricule + "/" + this.form.password + "/" + "Admin"
                  )
                  .then(passwordResponse => {
                    if (passwordResponse.data.status === 200) {
                      // Update PIN code
                      apiClient
                          .post(
                              `${this.baseUrlTmp}/account/user/pincode_by_matricule/` + this.form.matricule + "/" + this.form.pinCode + "/" + "Admin"
                          )
                          .then(pinResponse => {
                            if (pinResponse.data.status === 200) {
                              this.text = "Modification du mot de passe et du code PIN effectuée.\nVeuillez vous connecter.";
                            } else {
                              this.text = "Modification du mot de passe effectuée mais échec de la mise à jour du code PIN.\nVeuillez vous connecter.";
                            }
                            this.showAlert('info', 10000);

                            // Return to login mode
                            setTimeout(() => {
                              this.changePwd();
                            }, 3000);

                            this.$store.dispatch("logout").then(() => {
                              this.$router.push("/").catch(err => {
                                if (err.name !== 'NavigationDuplicated') {
                                  // Handle error if necessary
                                }
                              });
                            });
                          })
                          .catch(() => {
                            this.text = "Modification du mot de passe effectuée mais échec de la mise à jour du code PIN.\nVeuillez vous connecter.";
                            this.showAlert('info', 10000);

                            setTimeout(() => {
                              this.changePwd();
                            }, 3000);

                            this.$store.dispatch("logout").then(() => {
                              this.$router.push("/").catch(err => {
                                if (err.name !== 'NavigationDuplicated') {
                                  // Handle error if necessary
                                }
                              });
                            });
                          });
                    } else {
                      this.text = passwordResponse.data.message;
                      this.showAlert('error', 10000);

                      setTimeout(() => {
                        this.changePwd();
                      }, 10000);

                      this.$store.dispatch("logout").then(() => {
                        this.$router.push("/").catch(err => {
                          if (err.name !== 'NavigationDuplicated') {
                            // Handle error if necessary
                          }
                        });
                      });
                    }
                  })
                  .catch(() => {
                    this.text = "Serveur inaccessible.\nContactez l'administrateur.";
                    this.showAlert('error', 10000);

                    setTimeout(() => {
                      this.changePwd();
                    }, 10000);

                    this.$store.dispatch("logout").then(() => {
                      this.$router.push("/").catch(err => {
                        if (err.name !== 'NavigationDuplicated') {
                          // Handle error if necessary
                        }
                      });
                    });
                  });
            } else {
              this.text = "Serveur inaccessible.\nContactez l'administrateur.";
              this.showAlert('error', 10000);

              setTimeout(() => {
                this.changePwd();
              }, 10000);

              this.$store.dispatch("logout").then(() => {
                this.$router.push("/").catch(err => {
                  if (err.name !== 'NavigationDuplicated') {
                    // Handle error if necessary
                  }
                });
              });
            }
          })
          .catch(error => {
            this.text = "Serveur inaccessible.\nContactez l'administrateur.";
            this.showAlert('error', 10000);

            setTimeout(() => {
              this.changePwd();
            }, 10000);

            this.$store.dispatch("logout").then(() => {
              this.$router.push("/").catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                  // Handle error if necessary
                }
              });
            });
          });
    },
  },
  components: {
//      type,
  },
}
</script>

<style>
/* Variables CSS pour les couleurs principales */
:root {
  --primary-color: #01579B;
  --secondary-color: #0288D1;
  --text-color: #333;
  --bg-light: rgba(255, 255, 255, 0.95);
}

.login-page {
  min-height: 100vh;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.background-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  filter: blur(2px);
  transform: scale(1.05);
  z-index: 0;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(1, 87, 155, 0.6) 0%, rgba(0, 35, 75, 0.8) 100%);
  z-index: 1;
}

.content-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  z-index: 2;
}

.login-card {
  border-radius: 16px;
  overflow: hidden;
  backdrop-filter: blur(15px);
  background-color: rgba(255, 255, 255, 0.85) !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2) !important;
  max-width: 400px;
  margin: 0 auto;
  width: 100%;
}

.card-content {
  padding: 25px 20px;
}

.logo-wrapper {
  display: inline-block;
  margin-bottom: 12px;
}

.logo-image {
  max-width: 120px;
  height: auto;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.app-title {
  color: #01579B;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 1.5px;
  margin-bottom: 0;
  text-transform: uppercase;
}

.app-subtitle {
  color: #546E7A;
  font-weight: 500;
  margin-top: 4px;
  font-size: 16px;
}

.input-field {
  border-radius: 12px;
  transition: all 0.3s ease;
}

.input-field >>> input {
  text-align: center;
}

.input-field >>> .v-input__slot {
  min-height: 50px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease;
}

.input-field >>> .v-input__slot:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.section-card {
  background-color: rgba(1, 87, 155, 0.05);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  border-left: 3px solid #01579B;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  color: #01579B;
  font-weight: 600;
  font-size: 14px;
}

.recovery-link {
  color: #01579B;
  font-weight: 500;
  font-size: 14px;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
}

.recovery-link:hover {
  background-color: rgba(1, 87, 155, 0.08);
  transform: translateY(-1px);
}

.server-select {
  max-width: 120px;
  flex-shrink: 0;
}

.server-text {
  text-align: center;
  width: 100%;
}

.action-button {
  letter-spacing: 1px !important;
  transition: all 0.3s ease;
  text-transform: none;
  font-weight: 600;
  font-size: 15px;
}

.action-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(1, 87, 155, 0.25) !important;
}

.version-text {
  color: #78909C;
  font-size: 12px;
  margin-top: 20px;
  opacity: 0.8;
}

/* Animation de transition pour les alertes */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

/* Styles pour les appareils mobiles */
@media (max-width: 600px) {
  .card-content {
    padding: 20px;
  }

  .login-card {
    border-radius: 12px;
    margin: 16px;
  }

  .app-title {
    font-size: 24px;
  }

  .app-subtitle {
    font-size: 14px;
  }

  .logo-image {
    max-width: 100px;
  }

  .section-card {
    padding: 12px;
  }
}

/* Style spécifique pour les champs auto-remplis par les navigateurs */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px rgba(255, 255, 255, 0.1) inset !important;
  -webkit-text-fill-color: inherit !important;
  transition: background-color 5000s ease-in-out 0s;
}

.resend-link {
  color: #01579B;
  font-size: 14px;
  padding: 6px;
  border-radius: 4px;
  transition: all 0.3s ease;
  cursor: pointer;
  text-decoration: none;
  margin: 8px auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.resend-link:hover {
  background-color: rgba(1, 87, 155, 0.08);
}

.version-text {
  color: #78909C;
  font-size: 12px;
  margin-top: 20px;
  opacity: 0.8;
  transition: all 0.3s ease;
  text-align: center;
  cursor: pointer;
}

.version-text:hover {
  color: #01579B;
  opacity: 1;
}

.version-text.update-available {
  color: #43A047;
}

.version-text.update-available:hover {
  color: #2E7D32;
  font-weight: 500;
}

.update-message {
  margin-top: 3px;
  font-size: 10px;
  font-style: italic;
}

.server-selector-container {
  width: 100%;
  max-width: 250px;
  margin: 0 auto;
}

.server-select {
  width: 100%;
}

.server-text {
  text-align: center;
  width: 100%;
}

/* Pour assurer que le texte est bien centré dans le sélecteur */
.v-select__selection {
  width: 100%;
  text-align: center;
}

/* Styles pour l'icône d'aide */
.help-icon {
  cursor: pointer;
  transition: all 0.3s ease;
}

.help-icon:hover {
  color: #0288D1 !important;
  transform: scale(1.2);
}

/* ✅ AJOUTER : Styles pour le bouton d'aide */
.card-content {
  padding: 25px 20px;
  position: relative; /* IMPORTANT pour que le bouton se positionne par rapport à la carte */
}
</style>